import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./i18n/LangContext";
import { Shell } from "./components/site/Shell";
import Home from "./pages/Home";
import About from "./pages/About";
import WhatWeDo from "./pages/WhatWeDo";
import Quitanda from "./pages/Quitanda";
import Method from "./pages/Method";
import Contact from "./pages/Contact";

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<About />} />
            <Route path="/o-que-fazemos" element={<WhatWeDo />} />
            <Route path="/editora-quitanda" element={<Quitanda />} />
            <Route path="/metodo-construtor" element={<Method />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Shell>
        <Toaster position="bottom-left" />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
